import httpClient from './httpClient'

const apiAuthenticate = val => httpClient.post('/inc/authv2.php', val),
    apiGetUser = val => httpClient.post('/inc/authv2.php', val),
    apiGetPartList = () => httpClient.get('/inc/partlistv2.php'),
    apiFileOps = val => httpClient.post('/inc/' + val.filetouse, val)

export { apiAuthenticate, apiGetUser, apiGetPartList, apiFileOps }
